import { gql } from '@apollo/client/core';
import DealPreview from '~/apollo/fragments/Deal/DealPreview.fragment';

const CreateDealsMutation = gql`
  ${DealPreview}
  mutation createDeals($input: CreateDealsInput!) {
    createDeals(input: $input) {
      ...DealPreview
    }
  }
`;
export default CreateDealsMutation;
